import request from '@/assets/utils/request'

// demo.vue 接口调用示例
export function findtodolist(params) {
    return request({
        url: '/runtimeflow/findTodoList',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 首页分发接口
export function index(params) {
    return request({
        url: '/index',
        method: 'post',
        data: params,
        showLoading: true
    })
}
// 首页分发接口
export function logout(params) {
    return request({
        url: '/logout',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 初始化
export function init(params) {
    return request({
        url: '/init',
        method: 'post',
        data: params,
        showLoading: true
    })
}


// 获取贷款公司列表
export function getCompanyList(params) {
    return request({
        url: '/getCompanyList',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 贷款公司选择列表
export function companSelect(params) {
    return request({
        url: '/companySelect',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 登录 / 注册
export function login(params) {
    return request({
        url: '/login',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 获取短信验证码 登录
export function getLoginPhoneValidCode(params) {
    return request({
        url: '/getLoginPhoneValidCode',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 获取短信验证吗 四要素认证
export function getValiCode(params) {
    return request({
        url: '/getValidCode',
        method: 'post',
        data: params,
        showLoading: true
    })
}
// 获取短信验证吗 四要素认证
export function getRelationValidCode(params) {
    return request({
        url: '/getRelationValidCode',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 贷款审批额度 贷款状态更新
export function loanDetailHandler(params) {
    return request({
        url: '/loanDetailHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}
// 确认贷款申请 贷款状态更新
export function loanAmtConfirmHandler(params) {
    return request({
        url: '/loanAmtConfirmHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}


// 企业信息获取
export function queryCompanyInfo(params) {
    return request({
        url: '/queryCompanyInfo',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 企业信息确认放弃申请
export function giveUpApplication(params) {
    return request({
        url: '/giveUpApplication',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 问卷调查确认放弃申请
export function abandonApplication(params) {
    return request({
        url: '/abandonApplication',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 贷款类型选择
export function loanChannelSelect(params) {
    return request({
        url: '/loanChannelSelect',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 四要素认证
export function fourEleCheck(params) {
    return request({
        url: '/fourEleCheck',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 四要素认证反显
export function getUserFourElementsInfo(params) {
    return request({
        url: '/getUserFourElementsInfo',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 四要素认证反显提交
export function repeatApplyAuth(params) {
    return request({
        url: '/repeatApplyAuth',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 获取税局url地址
export function getLoanTaxAuthUrl(params) {
    return request({
        url: '/getLoanTaxAuthUrl',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 问卷调查页面生成订单
export function saveQuestionnaireSurvey(params) {
    return request({
        url: '/saveQuestionnaireSurvey',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// kyc 信息反显
export function getKycCorpInfo(params) {
    return request({
        url: '/kycCorpInfo',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// kyc 信息反显
export function sendKycSurvey(params) {
    return request({
        url: '/kycSurvey',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 税局回调
export function loanTaxAuthCallback(params) {
    return request({
        url: '/getLoanTaxResult',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 测试-文件上传
export function fileUpload(params) {
    return request({
        // url: 'https://rbwm-api.hsbc.com.hk/gdu-document-upload--zz-prod-proxy/v1/documents/',    //生产
        url: 'https://devcluster.api.p2g.netd2.hsbc.com.hk/gdu-document-upload--zz-cert-proxy/v2/documents',//测试
        method: 'post',
        data: params,
        formType: 2,//文件上传接口
        fileUploadHeaders:{
            // 'client_id':'8c0fef628dd94e30a0c7bcd7b1fd34e5',      //生产
            // 'client_secret':'461044D526404E9C97968a73f3b32Eb7',  //生产
            'client_id':'92bd3df2096049229307af50a4aa397a',
            'client_secret':'D84C1422480f4A5897a70fD902227e11',

            'Content-Type':'multipart/form-data',
        },
        showLoading: true
    })
}
// 上传第二步
export function fileUploadSec(params) {
    return request({
        // url: 'https://rbwm-api.hsbc.com.hk/gdu-document-upload-status--zz-prod-proxy/v1/documentStatus?ids=' + params.ids,               //生产
        url: 'https://devcluster.api.p2g.netd2.hsbc.com.hk/gdu-do cument-upload-status--zz-cert-proxy/v2/documentStatus?ids=' + params.ids,   // 测试
        method: 'get',
        // data: ,
        formType: 3,//文件上传接口
        fileUploadHeaders:{
            "client_secret" : "461044D526404E9C97968a73f3b32Eb7",
            "client_id2" : "8c0fef628dd94e30a0c7bcd7b1fd34e5",
            "client_secret2" : "461044D526404E9C97968a73f3b32Eb7",
            "client_id" : "8c0fef628dd94e30a0c7bcd7b1fd34e5"
        },
        showLoading: true
    })
}

export function fileUploadThr(params) {
    return request({
        url: '/fileUploadHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 公司信息反显
export function companyInformationQuery(params) {
    return request({
        url: '/getCompanyInfo',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 授权成功页面 下一步
export function getTaxCodeCheck(params) {
    return request({
        url: '/taxCodeCheck',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 上传补充资料 反显
export function fileListloadHandler(params) {
    return request({
        url: '/fileListLoadHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 上传补充资料信息反显 删除
export function fileListDelete(params) {
    return request({
        url: '/fileDetailDeleteHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}


// 上传补充资料 图片下载
export function GetFileDownloadKeyHandler(params) {
    return request({
        url: '/getFileDownloadKeyHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 社会信用代码
export function businessVerifyHandler(params) {
    return request({
        url: '/businessVerifyHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 贷款目的和类型选择
export function loanPurposeAndTypeSelect(params) {
    return request({
        url: '/loanPurposeAndTypeSelect',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 支付方式
export function paymentSelectHandler(params) {
    return request({
        url: '/paymentSelectHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 上传文件
export function submitOrderSuccessHandler(params) {
    return request({
        url: '/submitOrderSuccessHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// offerId反选
export function retrieveOfferHandler(params) {
    return request({
        url: '/retrieveOfferHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}
// 反显数据
export function pageDetailLoad(params) {
    return request({
        url: '/pageDetailLoad',
        method: 'post',
        data: params,
        showLoading: true
    })
}

export function commonPageDetailLoadHandler(params) {
    return request({
        url: '/commonPageDetailLoadHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 贷款发放信息反显数据
export function loadAnchorInfoHandler(params) {
    return request({
        url: '/loadAnchorInfoHandler',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 关联人添加
export function recordRelationHandler(params) {
    return request({
        url: '/recordRelation',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 关联人确认
export function loadRelation(params) {
    return request({
        url: '/loadRelation',
        method: 'post',
        data: params,
        showLoading: true
    })
}
// 提交订单
export function submitOrderSuccess(params) {
    return request({
        url: '/submitOrderSuccess',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 删除关联人
export function deleteRelation(params) {
    return request({
        url: '/deleteRelation',
        method: 'post',
        data: params,
        showLoading: true
    })
}
// 关联人认证授权
export function commonPageDetailLoad(params) {
    return request({
        url: '/commonPageDetailLoad',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 关联人认证授权
export function registerRelation(params) {
    return request({
        url: '/registerRelation',
        method: 'post',
        data: params,
        showLoading: true
    })
}
// 关联人认证授权
export function loadRelationByUserName(params) {
    return request({
        url: '/loadRelationByUserName',
        method: 'post',
        data: params,
        showLoading: true
    })
}

// 获取图片验证码
// export function signCaptcha(params) {
//     return request({
//         url: '/image/signCaptcha',
//         method: 'post',
//         data: params,
//         showLoading: true
//     })
// }

















// WEBPACK FOOTER //
// ./src/assets/api/dataBase.js